// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__jeAg3","footer":"ModalInfo_footer__22xO5"};